import React from "react";
import Skeleton from "react-loading-skeleton";
import { Navigate } from "react-router-dom";
import useExpenseBranches from "../../hooks/useExpenseBranches";
import { expenseBranchPath } from "../../utils/expenseBranchPath";
import IndustryGate from "./IndustryGate";

function FirstBranchRedirect() {
  const { branches, loaded } = useExpenseBranches(true);
  if (!loaded) {
    return (
      <div style={{ padding: "24px" }}>
        <Skeleton height={28} width={220} />
      </div>
    );
  }
  // Jobs live under a branch (/expense-management/branch/:centerId); the old
  // combined /expense-management URL lands on the first active branch, or on
  // Setup when there is none yet.
  return <Navigate to={branches[0] ? expenseBranchPath(branches[0].id) : "/expense-management/settings"} replace />;
}

// Kept for old bookmarks/links to /expense-management.
function ExpenseJobsRedirect() {
  return (
    <IndustryGate>
      <FirstBranchRedirect />
    </IndustryGate>
  );
}

export default ExpenseJobsRedirect;
